var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":"群发内容","visible":_vm.dialogVisible,"width":"350px","before-close":_vm.dialogBeforeClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',[_c('Iphone',{staticClass:"iphone",attrs:{"attachment":_vm.attachment}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }